import { Prescription } from './prescription.interface';

export interface GuaranteeApplicationSearchModel {
  page: number;
  pageSize: number;
  sortBy?: string;
  sortDirection?: string;
  userId?: string;
  patientName?: string;
  creatorName?: string;
  status?: GuaranteeApplicationStatus;
  id?: string;
  creatorType?: GuaranteeCreatorType | GuaranteeCreatorTypeString;
  creatorUserId?: string;
  isLiloStaff?: boolean;
  creationDate?: string;
  prescriptions?: Prescription[];
  description?: string;
  diagnoses?: DiagnosisResponse[];
  prescriptionName?: string;
}

export interface GuaranteeApplication {
  id: string;
  patientId: string;
  patientName: string;
  creatorType: GuaranteeCreatorType | GuaranteeCreatorTypeString;
  creatorUserId: string;
  creatorName: string;
  userId: string;
  isLiloStaff: boolean;
  creationDate: string;
  lastUpdateDate: string;
  lastUpdateByUserId: string;
  status: GuaranteeApplicationStatus;
  prescriptions?: Prescription[];
  description?: string;
  diagnoses?: DiagnosisResponse[];
  diagnosesCoverage?: GuaranteeDiagnosisCoverage[];
  contractId: string;
  partnerId: string;
  provider: string;
}

export interface GuaranteeDiagnosisCoverage {
  icd10Code: string;
  icpc2Code: string;
  protocolId?: string;
  isCovered: boolean;
}

export interface DiagnosisResponse {
  icd10: {
    code: string;
    name: string;
  };
  icpc2: {
    code: string;
    name: string;
  };
  role: string;
}

export enum GuaranteeCreatorType {
  Doctor = 0,
  HealthManager = 1,
}

export enum GuaranteeCreatorTypeString {
  Doctor = 'Doctor',
  HealthManager = 'HealthManager',
}

export enum GuaranteeApplicationStatus {
  Auto = 'Auto',
  Processed = 'Processed',
  WaitProcessing = 'WaitProcessing',
}

export enum GuaranteeStatus {
  Auto = 'Auto',
  Guaranteed = 'Guaranteed',
  NotGuaranteed = 'NotGuaranteed',
  Unknown = 'Unknown',
}

export const APPROVE_REASON: string = 'Проставлено автоматично після обробки в статус Гарантовано';
export const DECLINE_REASONS: string[] = [
  'Захворювання з МКХ-10, що включені до Переліку нестрахових захворювань',
  'Методи лікування, діагностики та профілактики, що не покриваються',
  'Медикаменти та витратні матеріали, що не покриваються за страховим продуктом "lilo©"',
  'Підстави для відмови Страховика',
  'навмисні дії Застрахованої особи, що призвели до настання страхового випадку',
  'подання Застрахованою особою свідомо неправдивих відомостей про факт чи обставини настання страхового випадку',
  'надання медичної допомоги не Застрахованій особі за Договором страхування',
  'створення Застрахованою особою Страховику перешкод у визначенні обставин, характеру та розміру збитків',
  'несвоєчасне повідомлення Страховика про настання страхового випадку',
  'перевищення лімітів зобов’язань Страховика за Договором страхування',
  'самостійне звернення Застрахованої особи до медичних установ та/або лікування у медичному закладі',
  'навмисне надання Застрахованою особою неправдивих відомостей з метою отримання медичної допомоги',
  'Захворювання, операції чи лікування, не завершені до початку дії Договору страхування',
  'Альтернативні консультації / дублювання обстежень / послуги, що не були письмово рекомендовані лікарями медичних закладів',
  'Нестрахове захворювання',
  'Не входять до Переліку медичних послуг',
  'Нетрадиційна медицина',
  'Психологічні та логопедичні послуги',
  'Пластичні та естетичні операції',
  'Серцево-судинні та нейрохірургічні операції',
  'Модифікація тіла',
  'Лікування доброякісних новоутворень',
  'Репродуктивні та контрацептивні послуги',
  'Профілактичні щеплення',
  'Реабілітація та відновлення',
  'Медична документація, що не пов’язана з настанням страхових випадків',
  'Допомога при вагітності та пологах',
  'Контрольна та уточнююча діагностика',
  'Лазерні технології',
  'Трансплантація органів та тканин',
  'Незавершені операції до початку дії Договору страхування',
  'Спеціальні дослідження (імунограми, гормони, ДНК-діагностика, алергопроби, онкомаркери, генетичні дослідження)',
  'Лікування станів, що не визначені за МКХ-10, до моменту постановки остаточного діагнозу',
  'Підтримуюча, замісна, гормональна терапія',
  'Самостійне придбання медикаментів/незареєстровані в Україні як ЛЗ',
  'Не передбачені протоколами / не погоджені з асистуючою компанією',
  'Препарати з антигіпоксичною, антиоксидантною дією та інші допоміжні препарати',
  'Специфічне медичне обладнання (стенти, шунти, протези тощо)',
  'Ортопедичні засоби (милиці, післяопераційні бандажі)',
  'Лінзи, окуляри, слухові апарати тощо',
  'Предмети гігієни та косметичні засоби',
  'Медичне обладнання та пристрої, що потребують додаткової оплати',
  'Інші нестрахові випадки',
  "Стани алкогольного, наркотичного або токсичного сп'яніння",
  'Обставини непереборної сили (військові дії, радіоактивне забруднення тощо)',
  'Заняття екстремальними видами спорту',
  'Діагноз, не включений до переліку страхових ризиків',
  'Лікування залишкових явищ або хронічних захворювань в стадії ремісії',
  'Захворювання або нещасні випадки, що виникли до початку дії договору страхування',
  'Надання медичної допомоги після завершення дії договору',
  'Випадки, що сталися протягом неоплаченого періоду страхування',
  'Випадки, що сталися поза межами дії договору страхування',
  'Лікування хронічних захворювань поза періодом загострення',
  'Витрати на благодійні внески',
  `Лікування захворювань, пов'язаних з інвалідністю`,
  'Вік застрахованої особи понад 51 рік',
  'Наявність онкологічних, психоневрологічних або інфекційних захворювань',
  'Захворювання, викликані особливо небезпечними інфекціями або епідеміями',
  'Госпіталізація або хірургічне втручання протягом перших 10 днів дії договору',
];

export const EDIT_REASONS: string[] = [
  'Зміна призначення від ПЛ (Невірна назва/кількість послуг/ліків)',
  'Зміна призначення від суміжного фахівця (Невірна назва/кількість послуг/ліків)',
  'Помилкове призначення від ПЛ',
  'Помилкове призначення від суміжного фахівця',
  'Нові симптоми в межах діагнозу',
  'Підготовка перед обстеженням (додати ЛЗ)',
  'Помилкове створення послуги ХМом',
  'Дубль призначення',
  'Клієнт замовив ЛЗ самостійно (/виконав послугу/записався самостійно)',
  'Клієнт відмовився від послуги',
  'Створення нових послуг в гарантації, тудушки на які були протерміновані',
];
